export default __webpack_public_path__ + "static/Mock-6b23539f4bf70305927a0464e8ae8913.png";